<script>
  export let itemKey;
  export let summary;
  export let productName;
</script>

<div class="item-summary">
  <div class="preview">
    <img id="{itemKey}-preview-front" class="preview-image" src={summary.frontPreview} alt="" />
    <img id="{itemKey}-preview-back" class="preview-image" src={summary.backPreview} alt="" />
  </div>
  <div class="details">
    <div class="heading">{productName}</div>
    <div class="information">
      {summary.count} Items @
      {#if summary.discountPercent && summary.discountPercent > 0}
        <span class="strike-through">${(summary.fullPrice / 100).toFixed(2)}</span>&nbsp;&rarr;
      {/if}
      <b>${(summary.price / 100).toFixed(2)}</b>
      <div class="print-summary">
        {#if summary.designSummary?.front}
          <div class="print-summary-item">
            <b>Front:</b>
            {summary.designSummary.front?.summary}
            &nbsp;
          </div>
        {/if}
        {#if summary.designSummary?.back}
          <div class="print-summary-item">
            <b>Back:</b>
            {summary.designSummary.back?.summary}
            &nbsp;
          </div>
        {/if}
        {#if summary.designSummary?.rightSide}
          <div class="print-summary-item">
            <div class="print-summary-item-value">
              <b>Right:</b>{summary.designSummary.rightSide?.summary}
              &nbsp;
            </div>
          </div>
        {/if}
        {#if summary.designSummary?.leftSide}
          <div class="print-summary-item">
            <div class="print-summary-item-value">
              <b>Left:</b>{summary.designSummary.leftSide?.summary}
              &nbsp;
            </div>
          </div>
        {/if}
      </div>
      <div class="size-summary">
        {#each summary.sizeSummary as sizeSummary}
          <div class="size">
            {@html (sizeSummary.size.gender !== 'mens' ? sizeSummary.size.gender[0] : '') +
              sizeSummary.size.name +
              ' ' +
              '&times' +
              sizeSummary.count}
          </div>
        {/each}
      </div>
    </div>
    <div class="item-total-price">
      {#if summary.discountPercent && summary.discountPercent > 0}
        <span class="strike-through">${(summary.fullTotal / 100).toFixed(2)}</span>&nbsp;&rarr;
      {/if}
      ${(summary.total / 100).toFixed(2)}
    </div>
    {#if summary.discountPercent && summary.discountPercent > 0}
      <div class="discount">({summary.discountPercent}% off for {summary.discountRange} pcs)</div>
    {/if}
  </div>
</div>

<style>
  .item-summary {
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 1rem;
    width: -webkit-fill-available;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .preview {
    display: flex;
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    align-items: center;
    min-width: 50%;
  }

  .preview-image {
    max-width: 50%;
    width: auto;
    height: auto;
  }

  .details {
    padding: 1rem;
    width: 100%;
  }

  .heading {
    text-transform: uppercase;
    font-family: 'Oswald';
    margin-bottom: 0.5rem;
    color: #4a4a4a;
  }

  .print-summary {
    display: flex;
    margin-top: 1rem;
  }

  .print-summary-item {
    font-size: 1.2rem;
  }

  .size-summary {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-top: 1rem;
  }

  .size {
    font-size: 1.3rem;
    text-transform: uppercase;
    background-color: #ff5800;
    padding: 0.3rem;
    border-radius: 0.3rem;
    color: white;
    margin-right: 0.5rem;
  }

  .item-total-price {
    display: flex;
    justify-content: right;
    font-weight: 700;
    margin-top: 1rem;
    color: #4a4a4a;
  }

  .strike-through {
    text-decoration: line-through;
    color: #4a4a4a;
    font-weight: normal;
  }

  .discount {
    display: flex;
    justify-content: right;
    font-weight: 500;
    font-size: smaller;
    color: #5b5a5a;
    padding-top: 0.2rem;
  }
</style>
